<div class="doc-notification" [ngClass]="verified ? 'success' : 'warning'">
  <span [ngClass]="verified ? 'icon-i-checkmark-circle' : 'icon-i-warning'"></span>
  <p>
    {{ 'account.summary.section.mobilePhoneValidation.' + (verified ? 'success' : 'warning') | translate }}
  </p>
</div>
<ng-container *ngIf="!verified">
  <div class="code-box">
    <p>
      {{ 'account.summary.section.mobilePhoneValidation.label' | translate: { phoneNumber: phone } }}
    </p>
    <div class="code-wrapper">
      <div class="input-boxes">
        <span
          *ngFor="let item of [0, 1, 2, 3, 4, 5]"
          [class.active]="verifyCodeInput.value[item]"
          [class.focus]="item === 0 ? true : verifyCodeInput.value[item - 1]"
          >{{ verifyCodeInput.value[item] }}</span
        >
      </div>
      <input
        #verifyCodeInput
        class="code-input"
        autocomplete="one-time-code"
        maxlength="6"
        type="string"
        [(ngModel)]="inputCode"
        (ngModelChange)="inputUpdate($event)"
      />
    </div>
    <p *ngIf="phoneError" class="error">{{ 'personal.error.bad_phone' | translate }}</p>
    <p *ngIf="codeError" class="error">{{ 'account.summary.section.mobilePhoneValidation.error' | translate }}</p>
    <a (click)="sendVerificationCode()">{{ 'account.summary.section.mobilePhoneValidation.ctaResend' | translate }}</a>
  </div>
  <p>
    {{ 'account.summary.section.mobilePhoneValidation.contact' | translate }}
    <a routerLink="/help">{{ 'account.summary.section.mobilePhoneValidation.link' | translate }}</a
    >.
  </p>
</ng-container>
